/* eslint-disable import/prefer-default-export */

import axios from './axios';

export const getGlobalContacts = ({ params } = {}) => axios.get(`contacts`, { params });